"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _customPage = _interopRequireDefault(require("@/components/customPage"));
var _editDialogCabinet = _interopRequireDefault(require("./dialog/editDialogCabinet"));
var _batteryType = require("@/api/iot/batteryType");
var _status = require("@/api/iot/status");
var _default = {
  components: {
    customPage: _customPage.default,
    editDialogCabinet: _editDialogCabinet.default
  },
  data: function data() {
    return {
      loading: true,
      searchForm: {},
      total: 0,
      tableData: [],
      editItem: null,
      batteryTypeList: [],
      batteryStatusList: [],
      brandTypeList: []
    };
  },
  mounted: function mounted() {
    this.getList();
    this.getBatteryTypeList();
    this.getBrandTypeList();
  },
  methods: {
    getBatteryTypeList: function () {
      var _getBatteryTypeList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _batteryType.batteryTypeListByCabinet)();
              case 2:
                res = _context.sent;
                if (res) {
                  this.batteryTypeList = res;
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getBatteryTypeList() {
        return _getBatteryTypeList.apply(this, arguments);
      }
      return getBatteryTypeList;
    }(),
    getBatteryStatusList: function () {
      var _getBatteryStatusList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _status.getBatteryStatusList)();
              case 2:
                res = _context2.sent;
                if (res) {
                  this.batteryStatusList = res;
                }
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function getBatteryStatusList() {
        return _getBatteryStatusList2.apply(this, arguments);
      }
      return getBatteryStatusList;
    }(),
    getBrandTypeList: function () {
      var _getBrandTypeList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _status.getBrandTypeList)();
              case 2:
                res = _context3.sent;
                if (res) {
                  this.brandTypeList = res;
                }
              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function getBrandTypeList() {
        return _getBrandTypeList2.apply(this, arguments);
      }
      return getBrandTypeList;
    }(),
    getList: function getList(flag) {
      var _this = this;
      // flag为true, 则不刷新表格
      var _this$$refs$customPag = this.$refs.customPage,
        page = _this$$refs$customPag.page,
        pageSize = _this$$refs$customPag.pageSize;
      if (!flag) {
        this.tableData = [];
      }
      this.loading = true;
      (0, _batteryType.batteryTypeListByCabinet)((0, _objectSpread2.default)({
        page: page,
        pageSize: pageSize
      }, this.searchForm)).then(function (res) {
        // console.log("batteryTypeList",res)
        _this.loading = false;
        _this.tableData = res.data || [];
        _this.total = res.total;
      });
    },
    // 编辑
    openEditDialog: function openEditDialog(val) {
      this.editItem = val || null;
      this.$refs.editDialogCabinet.dialogVisible = true;
    },
    // 删除
    removeItem: function removeItem(item) {
      var _this2 = this;
      this.$confirm('您确定要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _batteryType.batteryTypeDelByCabinet)({
          id: item.id
        }).then(function (res) {
          _this2.getList(true);
        });
      }).catch(function () {});
    },
    // 刷新
    refresh: function refresh(item) {
      this.$confirm('您确定要执行 刷新 操作吗?', '刷新', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        // delUser(item.id).then((res) => {
        //     this.getList(true)
        // })
      }).catch(function () {});
    },
    // 开门
    openDoor: function openDoor(item) {
      this.$confirm('您确定要执行 开门 操作吗?', '开门', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        // delUser(item.id).then((res) => {
        //     this.getList(true)
        // })
      }).catch(function () {});
    },
    // 补电
    charge: function charge(item) {
      this.$confirm('您确定要执行 补电 操作吗?', '补电', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        // delUser(item.id).then((res) => {
        //     this.getList(true)
        // })
      }).catch(function () {});
    },
    // 同步bms数据
    syncBms: function syncBms(item) {
      this.$func.isSuccess('同步bms数据');
    },
    // 批量操作
    handleCommand: function handleCommand(command) {},
    // 查询
    search: function search() {
      this.$refs.customPage.page = 1;
      this.getList();
    },
    // 重置
    reset: function reset() {
      this.searchForm = this.$options.data().searchForm;
      this.getList();
    }
  }
};
exports.default = _default;